<template>
  <div id="app">
    <v-app id="inspire">
<v-card v-model="show" color="#FFFF99">
            <v-card-title>
            <v-icon large left>mdi-excavator</v-icon>
             Listado de Productos y Servicios Clase A, B, C
          </v-card-title>
<v-card-text  class="pt-2">
<v-row dense>
          
  <v-col cols="8" sm="8" md="8">
      <v-text-field dense v-model="filtromaterial" label="Filtrar por Producto / Servicio">
      </v-text-field>
  </v-col> 
<v-col cols="2" sm="2" md="1"> 
<v-icon large left @click="cargarMateriales(filtromaterial)">mdi-magnify</v-icon>
</v-col>

</v-row>
</v-card-text>
</v-card>
<v-card>
<v-data-table
    dense
    :headers="headers"
    :items="listadoMateriales"
    locale="es-ar"
    class="elevation-1"
    :items-per-page="200"
    no-data-text="No hay datos disponibles"
    :footer-props="{
          itemsPerPageText: 'Materiales por página'
        }"
  >

  </v-data-table>
</v-card>
    </v-app>

  
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>

<script>
import axios from "../../../src/axios-auth";
export default {
   data: (vm) => ({
    listadoMateriales: [],
    headers: [
        {
          text: 'Clase',
          align: 'start',
          sortable: false,
          value: 'clase',
        },
        { text: 'Producto / Servicio', value: 'tipo' },
        { text: 'Descripción', value: 'descr' },
        
      ],
    }),

  computed: {
    show: {
      get() {
      this.cargarMateriales(false);
      return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          //this.vaciarModels();
          this.$emit("close");
        }
      },
    }
  },
methods:{
   scrollToTop() {
                window.scrollTo(0,0);
           }, 
    
    cargarMateriales(filtro) {
       
      let self = this;
      
        axios
        .get("/Obras/GetMaterialesClaseABC", { 
            params: {
            filtro: filtro,
          }
          
        })
        .then((response) => {
          self.listadoMateriales = response.data;
          
        })
        .catch((error) => {
          self.listadoMateriales = []
        });
      
    },

    
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500
      });
    },
  },

}
</script>
